import * as types from '../mutation-types'

const state = {
  search: JSON.parse(localStorage.getItem('orders_set_order_search'))
}

const mutations = {
  [types.ORDERPROGRESS_SET_ORDER_RESET] (state) {
    state.search = null
    localStorage.removeItem('orders_set_order_search')
  },
  [types.ORDERPROGRESS_SET_ORDER_SEARCH] (state, search) {
    state.search = {
      search: search.result,
      params: search.params
    }
    localStorage.setItem('orders_set_order_search', JSON.stringify(search.result))
  },
  [types.ORDERPROGRESS_DOCUMENT_SUPPLIERCUSTOMER] (state, types) {
    state.types = types
    localStorage.setItem('orderprogress_document_suppliercustomer', JSON.stringify(types))
  },
  [types.ORDERPROGRESS_DOCUMENT_STATUS] (state, types) {
    state.types = types
    localStorage.setItem('orderprogress_document_status', JSON.stringify(types))
  },
  [types.ORDERPROGRESS_TYPES_ORDER] (state, types) {
    state.types = types
    localStorage.setItem('orderprogress_types_order', JSON.stringify(types))
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/orders.js